
(function () {
  if (window.__llCartSyncBooted) return;
  window.__llCartSyncBooted = true;

  /* Grab fetch before anything patches it - including us, further down. Every
     request this file makes goes through NATIVE_FETCH, so our own cart writes
     never trip our own interceptor. */
  var NATIVE_FETCH = window.fetch ? window.fetch.bind(window) : null;
  if (!NATIVE_FETCH || !window.JSON || !window.Promise) return;

  /* ---- storage keys ---------------------------------------------------- */
  var K_IDX   = 'll_cart_v1';        /* {v,u,l:{lk:{i,q,t,p,s}},n,a,d} - the truth */
  var K_SEEN  = 'll_cart_seen';      /* the cart as this device last observed it */
  var K_OWNER = 'll_cart_owner';     /* which customer the index belongs to */
  var K_ORPH  = 'll_cart_orphan';    /* lines left behind by a signed-out account */
  var K_SKEW  = 'll_cart_skew';      /* ms to add to this device's clock */
  var K_DIRTY = 'll_cart_dirty';     /* '1' when a save is still owed */
  var K_MISS  = 'll_cart_missing';   /* lines the cart refused - sold out, usually */
  var K_DISC  = 'll_cart_disc';      /* discount code already applied on this device */

  var MAX_LINES = 150;
  var PUSH_WAIT = 700;          /* debounce on a burst of quantity taps */
  var PULL_GAP = 45000;         /* floor between FULL pulls */
  var POLL_FAST = 10000;        /* probe rate for a minute after any activity */
  var POLL_SLOW = 30000;        /* probe rate after that, while still visible */
  var POLL_FAST_FOR = 60000;
  /* How long a refused line goes un-retried. Short on purpose: a retry costs
     one failed POST, while getting this wrong shows a shopper "out of stock"
     against a card they could be buying. Singles get relisted, and a refusal
     can be transient (a sync mid-checkout, a hiccup), so six hours of taking
     the first failure's word for it was far too long. */
  var MISS_RETRY_MS = 10 * 60000;
  var RETRIES = [2000, 6000, 15000];

  var cfg = window.__llCartCfg || { customerId: null, endpoint: '', token: null };

  var me = cfg.customerId ? String(cfg.customerId) : null;

  /* ---- storage --------------------------------------------------------- */

  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function write(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function drop(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function readJSON(k, fallback) {
    try { var v = JSON.parse(read(k)); return v && typeof v === 'object' ? v : fallback; }
    catch (e) { return fallback; }
  }
  function writeJSON(k, v) { try { write(k, JSON.stringify(v)); } catch (e) {} }
  function count(o) { var n = 0; for (var k in o) if (o.hasOwnProperty(k)) n++; return n; }

  /* ---- the clock -------------------------------------------------------
     Every timestamp here is compared against every other one, across devices.
     Device clocks disagree - a phone a couple of minutes behind a laptop is
     ordinary - and using them raw means the slower device always loses:
     remove a card on the phone and the laptop's older "added" stamp still
     looks newer, so the removal is discarded and the card comes back.

     So this device's clock is not used for ordering. Every response carries
     the server's clock; we keep the offset and stamp in server time. One
     clock, one ordering, whatever any device believes the time is. */

  var CLOCK_SKEW = 0;
  var storedSkew = Number(read(K_SKEW));
  if (isFinite(storedSkew)) CLOCK_SKEW = storedSkew;

  function now() { return Date.now() + CLOCK_SKEW; }

  function noteServerClock(res) {
    if (!res || typeof res.now !== 'number') return;
    var skew = res.now - Date.now();
    /* Ignore jitter; a round trip is not a clock difference. */
    if (Math.abs(skew - CLOCK_SKEW) > 1500) {
      CLOCK_SKEW = skew;
      write(K_SKEW, String(skew));
    }
  }

  /* ---- line keys -------------------------------------------------------
     Shopify's own line item `key` is per-cart and changes when a line's
     properties or discounts change, so it cannot identify "the same line" on
     another device. This one is derived from the line's content, so both
     devices compute the same key for the same thing. */

  function hash(str) {
    var h = 5381;
    for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
    return h.toString(36);
  }

  function canonProps(props, plan) {
    var keys = props ? Object.keys(props).sort() : [];
    var s = '';
    /* Length-prefixed, not delimited: {"a b":"c"} and {"a":"b c"} must not
       flatten to the same string and collide on one line key. */
    for (var i = 0; i < keys.length; i++) {
      var pk = keys[i], pv = String(props[keys[i]]);
      s += pk.length + ':' + pk + ':' + pv.length + ':' + pv + ';';
    }
    return s + '|' + (plan || '');
  }

  function lineKey(variantId, props, plan) {
    var hasProps = props && count(props) > 0;
    if (!hasProps && !plan) return String(variantId);
    return String(variantId) + '~' + hash(canonProps(props, plan));
  }

  function cleanProps(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var out = {}, n = 0;
    for (var k in raw) {
      if (!raw.hasOwnProperty(k) || n >= 20) continue;
      var v = raw[k];
      if (v === null || typeof v === 'object') continue;
      out[String(k).slice(0, 80)] = String(v).slice(0, 400);
      n++;
    }
    return n ? out : null;
  }

  /* ---- the index ------------------------------------------------------- */

  function emptyIdx() {
    return { v: 1, u: 0, l: {}, n: { v: null, t: 0 }, a: {}, d: { v: null, t: 0 } };
  }

  function readIdx() {
    var idx = readJSON(K_IDX, null);
    if (!idx || !idx.l || typeof idx.l !== 'object') return emptyIdx();
    if (!idx.n) idx.n = { v: null, t: 0 };
    if (!idx.a) idx.a = {};
    if (!idx.d) idx.d = { v: null, t: 0 };
    return idx;
  }

  function writeIdx(idx) {
    idx.u = newest(idx);
    writeJSON(K_IDX, idx);
  }

  function newest(idx) {
    var u = 0, k;
    for (k in idx.l) if (idx.l[k].t > u) u = idx.l[k].t;
    for (k in idx.a) if (idx.a[k].t > u) u = idx.a[k].t;
    if (idx.n.t > u) u = idx.n.t;
    if (idx.d.t > u) u = idx.d.t;
    return u;
  }

  /* A cheap fingerprint, so we can tell "the merge changed something" without
     comparing two objects field by field. */
  function sig(idx) {
    var keys = Object.keys(idx.l).sort();
    var s = '';
    for (var i = 0; i < keys.length; i++) {
      var e = idx.l[keys[i]];
      s += keys[i] + ':' + e.q + ':' + e.t + ';';
    }
    s += '|n' + (idx.n.v || '') + idx.n.t + '|d' + (idx.d.v || '') + idx.d.t + '|';
    var ak = Object.keys(idx.a).sort();
    for (var j = 0; j < ak.length; j++) s += ak[j] + '=' + (idx.a[ak[j]].v || '') + idx.a[ak[j]].t + ';';
    return s;
  }

  /* Merge rules, matched line for line with ll-cart-sync.php. Both sides run
     them so a device is correct even between round trips. */

  function mergeLines(a, b) {
    var out = {}, k;
    for (k in a) out[k] = a[k];
    for (k in b) {
      var cur = out[k];
      if (!cur) { out[k] = b[k]; continue; }
      /* Newest stamp wins; on a tie the LARGER quantity wins, because keeping
         an item someone can see and remove beats dropping one they cannot. */
      if (b[k].t > cur.t || (b[k].t === cur.t && b[k].q > cur.q)) out[k] = b[k];
    }
    return out;
  }

  function mergeScalar(a, b) { return (b && b.t > (a ? a.t : 0)) ? b : a; }

  function mergeAttrs(a, b) {
    var out = {}, k;
    for (k in a) out[k] = a[k];
    for (k in b) if (!out[k] || b[k].t > out[k].t) out[k] = b[k];
    return out;
  }

  function mergeState(local, remote) {
    return {
      v: 1, u: 0,
      l: mergeLines(local.l, remote.l || {}),
      n: mergeScalar(local.n, remote.n),
      a: mergeAttrs(local.a, remote.a || {}),
      d: mergeScalar(local.d, remote.d)
    };
  }

  /* Drop dead weight so the payload cannot grow without limit. Live lines are
     never dropped for age - a cart from three months ago is still that
     shopper's cart - only tombstones are. */
  function prune(idx) {
    var live = [], dead = [], k;
    for (k in idx.l) (idx.l[k].q > 0 ? live : dead).push(k);
    var cutoff = now() - 30 * 86400000;
    for (var i = 0; i < dead.length; i++) {
      if (idx.l[dead[i]].t < cutoff) delete idx.l[dead[i]];
    }
    if (live.length > MAX_LINES) {
      live.sort(function (x, y) { return idx.l[y].t - idx.l[x].t; });
      for (var j = MAX_LINES; j < live.length; j++) delete idx.l[live[j]];
    }
    return idx;
  }

  /* ---- what this device last saw --------------------------------------- */

  function readSeen() {
    var s = readJSON(K_SEEN, null);
    if (!s || !s.l) return { l: {}, n: null, a: {} };
    if (!s.a) s.a = {};
    return s;
  }

  function writeSeen(live, cart) {
    var l = {}, k;
    /* The cart line key is kept so a caller holding one (every remove control
       on the cart page has line keys, not index keys) can be mapped back to
       this index, which is keyed by variant + properties + selling plan. */
    for (k in live) l[k] = { q: live[k].q, i: live[k].i, p: live[k].p, s: live[k].s, key: live[k].key };
    writeJSON(K_SEEN, {
      l: l,
      n: (cart && typeof cart.note === 'string') ? cart.note : '',
      a: (cart && cart.attributes) ? cart.attributes : {},
      t: now()
    });
  }

  /* ---- lines the cart would not take ----------------------------------- */

  function readMissing() { return readJSON(K_MISS, {}); }

  function noteMissing(lk, line, why) {
    var miss = readMissing();
    miss[lk] = {
      i: line.i, q: line.q, at: Date.now(),
      m: line.m || null,
      why: String(why || '').slice(0, 200)
    };
    writeJSON(K_MISS, miss);
    emit('unavailable', { lineKey: lk, variantId: line.i, reason: miss[lk].why });
  }

  /* A refused line is NOT tombstoned. Sold out today is not "the shopper
     removed it": another device may still be showing it, and singles come back
     when a duplicate is listed. So it stays in the index, we stop retrying it
     for a few hours, and the cart page can show it as unavailable. */
  function isMissing(lk) {
    var miss = readMissing();
    var m = miss[lk];
    if (!m) return false;
    if (Date.now() - m.at > MISS_RETRY_MS) { delete miss[lk]; writeJSON(K_MISS, miss); return false; }
    return true;
  }

  function clearMissing(lk) {
    var miss = readMissing();
    if (miss[lk]) { delete miss[lk]; writeJSON(K_MISS, miss); }
  }

  /* Retried once per page load, then not again until the record ages out.
     A timer alone was wrong: a shopper looking at "out of stock" against a card
     that is back in stock will reload the page, and reloading has to be the
     thing that fixes it. Retrying on every reconcile instead would fire on
     every poll that moved, for a line we have good reason to think is gone. */
  var retriedThisLoad = {};

  function shouldTryMissing(lk) {
    if (!isMissing(lk)) return true;      /* no record, or it has aged out */
    return !retriedThisLoad[lk];
  }

  /* ---- the Shopify cart ------------------------------------------------ */

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function readCart() {
    return NATIVE_FETCH(root() + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    }).catch(function () { return null; });
  }

  function cartPost(path, body) {
    return NATIVE_FETCH(root() + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok) {
          var err = new Error((j && (j.description || j.message)) || ('http ' + r.status));
          err.status = r.status;
          throw err;
        }
        return j;
      });
    });
  }

  /* Enough of the product to name it on another device.
     Without this a line that cannot be re-added is just a variant id, and the
     cart page can only say "something is unavailable", which is no better than
     the silence it replaces. The device that HAS the line is the only one that
     knows what it is, so it records that when it stamps it. */
  function lineMeta(it) {
    var out = {};
    var handle = it.handle || '';
    if (!handle && it.url) {
      var m = String(it.url).match(/\/products\/([^?#\/]+)/);
      if (m) handle = m[1];
    }
    if (handle) out.h = String(handle).slice(0, 120);

    var name = it.product_title || it.title || '';
    if (name) out.n = String(name).slice(0, 160);

    var img = '';
    if (it.featured_image && it.featured_image.url) img = it.featured_image.url;
    else if (typeof it.image === 'string') img = it.image;
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) out.im = img.slice(0, 400);

    return (out.h || out.n) ? out : null;
  }

  function normalise(cart) {
    var map = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var props = cleanProps(it.properties);
      var plan = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan)
        ? String(it.selling_plan_allocation.selling_plan.id) : null;
      var lk = lineKey(it.variant_id, props, plan);
      if (map[lk]) { map[lk].q += it.quantity; continue; }
      map[lk] = {
        i: String(it.variant_id),
        q: it.quantity,
        p: props,
        s: plan,
        key: it.key,
        title: it.product_title || it.title || '',
        m: lineMeta(it)
      };
    }
    return map;
  }

  /* ---- status ---------------------------------------------------------- */

  var syncState = '';

  function emit(name, detail) {
    try { document.dispatchEvent(new CustomEvent('ll:cart:' + name, { detail: detail || {} })); }
    catch (e) {}
  }

  function setState(state, detail) {
    syncState = state;
    emit('sync', { state: state, detail: detail || '', customerId: me });
    var els = document.querySelectorAll('[data-cart-sync-status]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (state === 'saving') el.textContent = 'Saving your basket...';
      else if (state === 'ok') el.textContent = 'Basket saved to your account';
      else if (state === 'auth') el.textContent = 'Sign in again to sync your basket';
      else if (state === 'err') el.textContent = detail || 'Basket sync pending, will retry';
      else if (state === 'guest') el.textContent = 'Sign in to keep this basket on all your devices';
      else el.textContent = '';
    }
  }

  function setDirty(on) { if (on) write(K_DIRTY, '1'); else drop(K_DIRTY); }

  /* Tell the theme something moved. Themes disagree about how to be told, so
     say it several ways and update the obvious counters ourselves. Empire fires
     jQuery events; newer themes listen on document. */
  function notifyTheme(cart) {
    if (!cart) return;
    var names = ['cart:updated', 'cart:refresh', 'cart:build', 'ajaxProduct:added'];
    for (var i = 0; i < names.length; i++) {
      try { document.dispatchEvent(new CustomEvent(names[i], { detail: { cart: cart } })); } catch (e) {}
    }
    if (window.jQuery) {
      try { window.jQuery(document).trigger('cart:updated', [cart]); } catch (e) {}
      try { window.jQuery(document).trigger('cart.requestComplete', [cart]); } catch (e) {}
    }
    var sel = '[data-cart-count], .cart-count, .cart-item-count, .site-header__cart-count';
    var els = document.querySelectorAll(sel);
    for (var j = 0; j < els.length; j++) {
      els[j].textContent = String(cart.item_count);
      els[j].setAttribute('data-cart-count', String(cart.item_count));
    }
    emit('applied', { cart: cart });
  }

  /* The cart page renders server-side, so once we have changed the cart under
     it the only honest thing is to re-render. Guarded so it can never loop. */
  function refreshCartPage() {
    if (!/\/cart(\/|$)/.test(location.pathname)) return;
    if (window.LLCartPage && typeof window.LLCartPage.refresh === 'function') {
      window.LLCartPage.refresh();
      return;
    }
    try {
      var last = Number(sessionStorage.getItem('ll_cart_reloaded') || 0);
      if (Date.now() - last < 8000) return;
      sessionStorage.setItem('ll_cart_reloaded', String(Date.now()));
    } catch (e) {}
    location.reload();
  }

  /* ---- network --------------------------------------------------------- */

  function endpointUrl() {
    var url = cfg.endpoint || '';
    if (!url) return '';
    if (url.indexOf('http') === 0) return url;
    return root().replace(/\/$/, '') + (url.indexOf('/') === 0 ? url : '/' + url);
  }

  function canSync() {
    if (!me || !endpointUrl()) return false;
    /* Either we carry a signed token, or we are going through an App Proxy and
       Shopify signs the request for us. */
    return !!cfg.token || String(cfg.endpoint || '').indexOf('/apps/') === 0;
  }

  function headers() {
    var h = { 'Accept': 'application/json' };
    if (cfg.token) h['X-LL-Auth'] = cfg.token;
    return h;
  }

  function remoteToIdx(j) {
    return {
      v: 1, u: j.u || 0,
      l: (j && j.l && typeof j.l === 'object') ? j.l : {},
      n: (j && j.n) ? j.n : { v: null, t: 0 },
      a: (j && j.a) ? j.a : {},
      d: (j && j.d) ? j.d : { v: null, t: 0 }
    };
  }

  var pushTimer = null;
  var retryTimer = null;
  var inFlight = false;
  var lastPull = 0;
  var pollTimer = null;
  var lastActivity = 0;
  var serverVersion = -1;

  function push(attempt) {
    attempt = attempt || 0;
    if (!canSync()) { setState('guest'); return Promise.resolve(false); }
    if (inFlight) { setDirty(true); return Promise.resolve(false); }

    var idx = readIdx();
    inFlight = true;
    setState('saving');

    return NATIVE_FETCH(endpointUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json',
                 'X-LL-Auth': cfg.token || '' },
      body: JSON.stringify({ v: 1, u: newest(idx), l: idx.l, n: idx.n, a: idx.a, d: idx.d })
    }).then(function (r) {
      if (r.status === 401) { var e = new Error('auth'); e.fatal = true; throw e; }
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      inFlight = false;
      noteServerClock(j);
      if (typeof j.u === 'number') serverVersion = j.u;
      setDirty(false);
      setState('ok');
      /* The server merges too, so its answer can hold another device's change
         we have not seen. Fold it in and let it reach the cart. */
      return absorb(j);
    }).catch(function (err) {
      inFlight = false;
      setDirty(true);
      if (err && err.fatal) {
        /* Expired or bad token. A page load mints a fresh one - hammering a
           dead token helps nobody. */
        setState('auth');
        return false;
      }
      setState('err');
      if (attempt < RETRIES.length) {
        clearTimeout(retryTimer);
        retryTimer = setTimeout(function () { push(attempt + 1); }, RETRIES[attempt]);
      }
      return false;
    });
  }

  function schedulePush(wait) {
    if (!canSync()) { setState('guest'); return; }
    setDirty(true);
    noteActivity();
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { push(0); }, wait == null ? PUSH_WAIT : wait);
  }

  function pull(force) {
    if (!canSync()) return Promise.resolve(false);
    if (!force && Date.now() - lastPull < PULL_GAP) return Promise.resolve(false);
    lastPull = Date.now();

    return NATIVE_FETCH(endpointUrl(), {
      method: 'GET', credentials: 'same-origin', headers: headers()
    }).then(function (r) {
      if (r.status === 401) { var e = new Error('auth'); e.fatal = true; throw e; }
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      noteServerClock(j);
      if (typeof j.u === 'number') serverVersion = j.u;
      return absorb(j);
    }).catch(function (err) {
      /* Offline, or the endpoint is down. The cart on this device is still
         right for this device and the pending flag survives, so nothing is
         lost - it just is not shared yet. */
      if (err && err.fatal) setState('auth');
      else if (syncState !== 'saving') setState('err');
      return false;
    });
  }

  /* Fold a server response into the local index, then let reconcile push the
     result into the actual Shopify cart. */
  function absorb(j) {
    var local = readIdx();
    var merged = prune(mergeState(local, remoteToIdx(j || {})));
    var moved = sig(merged) !== sig(local);
    if (moved) writeIdx(merged);
    return reconcile('absorb').then(function () {
      /* We hold something the account does not - send it up. */
      if (sig(readIdx()) !== sig(remoteToIdx(j || {}))) schedulePush(moved ? 400 : PUSH_WAIT);
      else setState('ok');
      return moved;
    });
  }

  /* ---- polling --------------------------------------------------------- */

  function probe() {
    if (!canSync() || document.hidden) return Promise.resolve(false);
    var url = endpointUrl();
    return NATIVE_FETCH(url + (url.indexOf('?') > -1 ? '&' : '?') + 'probe=1', {
      method: 'GET', credentials: 'same-origin', headers: headers()
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      noteServerClock(j);
      if (!j || typeof j.u !== 'number') return false;
      /* Only pay for the full index once the number has actually moved. */
      if (j.u !== serverVersion) { serverVersion = j.u; return pull(true); }
      return false;
    }).catch(function () { return false; });
  }

  function pollDelay() {
    return (Date.now() - lastActivity < POLL_FAST_FOR) ? POLL_FAST : POLL_SLOW;
  }

  function schedulePoll() {
    clearTimeout(pollTimer);
    if (!canSync() || document.hidden) return;
    pollTimer = setTimeout(function () { probe().then(schedulePoll); }, pollDelay());
  }

  function noteActivity() { lastActivity = Date.now(); schedulePoll(); }

  /* ---- reconcile: the heart -------------------------------------------- */

  var busy = false;
  var again = false;
  var applying = false;
  var sawExplicitClear = false;

  /* Did THIS device write to the cart since the last pass? A real removal
     always arrives through change.js / update.js / clear.js and we see it go
     past. Lines that disappear with no such call did not disappear because
     anybody asked - see wipeSuspect below. */
  var sawCartMutation = false;

  /* Set while a different account is taking this device over. It has to be a
     flag rather than an argument because the reconcile that matters is the one
     pull() runs for itself, several promises away from takeOver(). */
  var takingOver = false;

  /**
   * One pass:
   *   A. read the live cart and work out what THIS device did since it last
   *      looked, stamping those changes into the index
   *   B. apply the index back to the cart, so what another device did lands here
   *   C. remember the resulting cart as `seen`
   */
  function reconcile(reason, authoritative) {
    if (busy) { again = true; return Promise.resolve(false); }
    busy = true;
    var auth = authoritative || takingOver;

    return readCart().then(function (cart) {
      if (!cart) return false;

      var live = normalise(cart);
      var seen = readSeen();
      var idx = readIdx();
      var t = now();
      var changed = false;
      var k;

      /* Everything this device was holding vanished at once, and no cart
         request went past to explain it. That is not a shopper emptying their
         basket one card at a time - it is a cart permalink
         (/cart/<variant>:1, which is exactly what our price-label QR codes
         are, and which REPLACES the cart rather than adding to it), an expired
         cart cookie, or a checkout that bounced.

         Note the test is "all of them, with no request", not "the cart is
         empty": a permalink leaves its own item behind, so an empty-cart check
         would sail straight past the very case it was written for. Tombstoning
         on this guess would push the wipe out to every other device, so we
         refuse to read it as a removal and let the index put the cart back. */
      var stillHere = 0;
      for (k in seen.l) if (live[k]) stillHere++;
      var wipeSuspect = count(seen.l) > 1 && stillHere === 0
        && !sawExplicitClear && !sawCartMutation;
      if (wipeSuspect) emit('restored', { from: count(seen.l) });

      /* ---- A. local -> index ---- */

      /* A line that is sitting in the cart is not unavailable, whatever we
         recorded about it earlier. This has to happen BEFORE the "nothing
         happened here" skip below, because a line that is present and
         unchanged skips the rest of the loop - which is how a stale refusal
         used to survive for its full retry window and keep telling the shopper
         a card was out of stock while it sat in their basket. */
      var miss = readMissing();
      var missDirty = false;

      for (k in live) {
        if (miss[k]) { delete miss[k]; missDirty = true; }
        if (seen.l[k] && seen.l[k].q === live[k].q) continue;   /* nothing happened here */
        /* Taking the device over: lines already sitting in the cart are the
           PREVIOUS account's, so they must not be stamped into this one's
           index. Step B clears them out instead. */
        if (auth && !idx.l[k]) continue;
        idx.l[k] = {
          i: live[k].i, q: live[k].q, t: t, p: live[k].p, s: live[k].s,
          m: live[k].m || (idx.l[k] && idx.l[k].m) || null
        };
        changed = true;
      }
      if (missDirty) writeJSON(K_MISS, miss);
      for (k in seen.l) {
        if (live[k] || wipeSuspect) continue;
        if (idx.l[k] && idx.l[k].q === 0) continue;
        idx.l[k] = {
          i: seen.l[k].i, q: 0, t: t, p: seen.l[k].p, s: seen.l[k].s,
          m: (idx.l[k] && idx.l[k].m) || null
        };
        changed = true;
      }

      var liveNote = typeof cart.note === 'string' ? cart.note : '';
      if (seen.n !== null && liveNote !== seen.n) {
        idx.n = { v: liveNote || null, t: t };
        changed = true;
      }

      var liveAttrs = cart.attributes || {};
      for (k in liveAttrs) {
        if (String(seen.a[k] == null ? '' : seen.a[k]) === String(liveAttrs[k])) continue;
        idx.a[k] = { v: String(liveAttrs[k]) || null, t: t };
        changed = true;
      }
      for (k in seen.a) {
        if (k in liveAttrs) continue;
        idx.a[k] = { v: null, t: t };
        changed = true;
      }

      /* A discount code is never readable back out of the cart - Shopify only
         applies manual codes at checkout - so it is captured where it enters:
         a ?discount= link or the cookie Shopify sets. */
      var code = capturedDiscount();
      if (code && code !== (idx.d.v || '')) { idx.d = { v: code, t: t }; changed = true; }

      if (changed) { prune(idx); writeIdx(idx); }

      /* ---- B. index -> cart ---- */
      return applyToCart(idx, live, cart, auth).then(function (result) {
        /* ---- C. remember where we ended up ---- */
        var finalCart = result.cart || cart;
        writeSeen(result.live || live, finalCart);
        sawExplicitClear = false;
        sawCartMutation = false;

        if (result.touched) { notifyTheme(finalCart); refreshCartPage(); }
        if (changed) schedulePush();
        return changed || result.touched;
      });
    }).catch(function () {
      return false;
    }).then(function (r) {
      busy = false;
      if (again) { again = false; setTimeout(function () { reconcile('again'); }, 50); }
      return r;
    });
  }

  /**
   * Make the Shopify cart look like the index.
   *
   * Quantity changes go through change.js one at a time, addressed by the line
   * item key, so a cart holding the same variant twice with different
   * properties cannot have the wrong line touched. Adds go one at a time too -
   * a batched add.js fails whole if ANY item in it is unavailable, and on a
   * catalogue of one-of-one Japanese singles that would mean a single sold-out
   * card silently blocking the restore of everything else.
   */
  function applyToCart(idx, live, cart, authoritative) {
    var changes = [];
    var adds = [];
    var k;

    for (k in live) {
      var want = idx.l[k];
      if (!want) {
        /* Unknown to the index. Normally impossible - step A just stamped it -
           so this is the shared-computer takeover, where the cart still holds
           the previous account's lines. */
        if (authoritative) changes.push({ lk: k, q: 0 });
        continue;
      }
      if (want.q !== live[k].q) changes.push({ lk: k, q: want.q });
    }
    for (k in idx.l) {
      if (idx.l[k].q > 0 && !live[k] && shouldTryMissing(k)) adds.push({ lk: k, line: idx.l[k] });
    }

    var wants = cartFields(idx, cart);
    if (!changes.length && !adds.length && !wants) {
      return Promise.resolve({ cart: cart, live: live, touched: false });
    }

    applying = true;
    var current = live;
    var touched = false;
    var chain = Promise.resolve();

    changes.forEach(function (op) {
      chain = chain.then(function () {
        var target = current[op.lk];
        if (!target || target.q === op.q) return;
        return cartPost('cart/change.js', { id: target.key, quantity: op.q })
          .then(function (c) { if (c) { current = normalise(c); cart = c; touched = true; } })
          .catch(function () { /* the line moved under us; the next pass sees it */ });
      });
    });

    adds.forEach(function (op) {
      chain = chain.then(function () {
        retriedThisLoad[op.lk] = true;
        var item = { id: Number(op.line.i), quantity: op.line.q };
        if (op.line.p) item.properties = op.line.p;
        if (op.line.s) item.selling_plan = Number(op.line.s);
        return cartPost('cart/add.js', { items: [item] })
          .then(function () { touched = true; clearMissing(op.lk); })
          .catch(function (err) { noteMissing(op.lk, op.line, err && err.message); });
      });
    });

    if (wants) {
      chain = chain.then(function () {
        return cartPost('cart/update.js', wants)
          .then(function (c) { if (c) { current = normalise(c); cart = c; touched = true; } })
          .catch(function () {});
      });
    }

    chain = chain.then(function () { return applyDiscount(idx); });

    return chain.then(function () {
      /* add.js answers with the lines it added, not the cart, so when anything
         was added we re-read once to end on the truth. */
      if (adds.length) {
        return readCart().then(function (c) {
          applying = false;
          if (c) { cart = c; current = normalise(c); }
          return { cart: cart, live: current, touched: touched };
        });
      }
      applying = false;
      return { cart: cart, live: current, touched: touched };
    }).catch(function () {
      applying = false;
      return { cart: cart, live: current, touched: touched };
    });
  }

  /** The note and attributes half of an update.js call, or null if in step. */
  function cartFields(idx, cart) {
    var body = null;

    if (idx.n.t > 0) {
      var wantNote = idx.n.v || '';
      if (wantNote !== (typeof cart.note === 'string' ? cart.note : '')) {
        body = body || {};
        body.note = wantNote;
      }
    }

    var wantAttrs = {};
    var anyAttr = false;
    var haveAttrs = cart.attributes || {};
    for (var k in idx.a) {
      if (!idx.a[k].t) continue;
      var v = idx.a[k].v === null ? '' : idx.a[k].v;
      wantAttrs[k] = v;
      if (String(haveAttrs[k] == null ? '' : haveAttrs[k]) !== String(v)) anyAttr = true;
    }
    if (anyAttr) { body = body || {}; body.attributes = wantAttrs; }

    return body;
  }

  /* ---- discount codes --------------------------------------------------
     Shopify only applies manual codes at checkout, so a code is not readable
     from /cart.js and cannot be set through the cart API. What we CAN do is
     notice the code as it arrives - a ?discount= link, or the cookie Shopify
     writes - and replay it on the other device by fetching the same
     /discount/<code> route, which sets that cookie there too. */

  function capturedDiscount() {
    try {
      var m = location.search.match(/[?&]discount=([^&]+)/i);
      if (m) return decodeURIComponent(m[1]).slice(0, 64);
      var c = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      if (c) return decodeURIComponent(c[1]).slice(0, 64);
    } catch (e) {}
    return '';
  }

  function applyDiscount(idx) {
    var code = idx.d && idx.d.v;
    if (!code) return Promise.resolve();
    if (read(K_DISC) === code) return Promise.resolve();
    if (capturedDiscount() === code) { write(K_DISC, code); return Promise.resolve(); }

    return NATIVE_FETCH(root() + 'discount/' + encodeURIComponent(code), {
      method: 'GET', credentials: 'same-origin', redirect: 'follow'
    }).then(function () {
      write(K_DISC, code);
      emit('discount', { code: code });
    }).catch(function () {});
  }

  /* ---- watching this device's own cart --------------------------------- */

  var nudgeTimer = null;

  function nudge() {
    sawCartMutation = true;
    clearTimeout(nudgeTimer);
    nudgeTimer = setTimeout(function () { noteActivity(); reconcile('local'); }, 300);
  }

  function patchNetwork() {
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;

    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCart = CART_RE.test(String(url));
      if (isCart && !applying && /\/cart\/clear/i.test(String(url))) sawExplicitClear = true;
      var p = NATIVE_FETCH.apply(window, arguments);
      if (isCart && !applying) {
        p.then(function () { nudge(); }, function () {});
      }
      return p;
    };

    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__llCartUrl = url;
      return open.apply(this, arguments);
    };
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var url = String(this.__llCartUrl || '');
      if (CART_RE.test(url) && !applying) {
        if (/\/cart\/clear/i.test(url)) sawExplicitClear = true;
        try { this.addEventListener('loadend', function () { nudge(); }); } catch (e) {}
      }
      return send.apply(this, arguments);
    };

    /* A theme that posts the add-to-cart form the old-fashioned way navigates,
       and the next page load reconciles anyway - but flag activity so the poll
       is quick when they land. */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.action && /\/cart\/add/i.test(String(f.action))) noteActivity();
    }, true);
  }

  /* ---- ownership -------------------------------------------------------
     localStorage belongs to the browser, not to whoever is signed into it. On
     a shared computer the previous person's cart is still sitting in the cart
     cookie when the next one signs in, and merging that into their account
     would not just show them someone else's basket - it would push it to all
     of their devices.

     So the moment an account signs OUT, the lines it left in the cart are
     recorded as orphans. Anything added after that belongs to whoever is
     browsing now, and only that is claimed at the next sign-in. */

  function markOrphans() {
    return readCart().then(function (cart) {
      var orphans = {};
      var live = normalise(cart);
      for (var k in live) orphans[k] = 1;
      writeJSON(K_ORPH, orphans);
      /* Start the guest with a clean index but an accurate `seen`, so the
         account's leftovers are not re-stamped as this guest's doing. */
      writeJSON(K_IDX, emptyIdx());
      writeSeen(live, cart);
      write(K_OWNER, '');
      drop(K_DISC);
    });
  }

  function adopt() {
    /* Stamp whatever this guest built, then claim it. */
    return reconcile('adopt').then(function () {
      var idx = readIdx();
      var orphans = readJSON(K_ORPH, {});
      var claim = {};
      for (var k in idx.l) if (!orphans[k]) claim[k] = idx.l[k];

      if (!canSync()) return false;
      setState('saving');
      return NATIVE_FETCH(endpointUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json',
                   'X-LL-Auth': cfg.token || '' },
        body: JSON.stringify({ v: 1, adopt: true, u: newest(idx), l: claim,
                               n: idx.n, a: idx.a, d: idx.d })
      }).then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.json();
      }).then(function (j) {
        noteServerClock(j);
        if (typeof j.u === 'number') serverVersion = j.u;
        /* Only now does this device belong to the account. If the claim failed
           we leave the owner unset and try again on the next page - adoption is
           a union, so running it twice is harmless. */
        write(K_OWNER, me);
        drop(K_ORPH);
        writeIdx(remoteToIdx(j));
        emit('adopted', { lines: count(claim) });
        setState('ok');
        return reconcile('adopted');
      }).catch(function () {
        setState('err');
        return false;
      });
    });
  }

  function takeOver() {
    /* A different account, with no sign-out seen in between. Nothing is lost:
       the previous account's cart is already saved server-side under their id,
       so the only job here is to stop showing it to this one. */
    writeJSON(K_IDX, emptyIdx());
    writeJSON(K_SEEN, { l: {}, n: null, a: {} });
    writeJSON(K_MISS, {});
    drop(K_DISC);
    write(K_OWNER, me);
    takingOver = true;
    return pull(true).then(function () {
      return reconcile('takeover', true);
    }).then(function (r) {
      takingOver = false;
      return r;
    }, function () {
      takingOver = false;
      return false;
    });
  }

  /* ---- boot ------------------------------------------------------------ */

  function boot() {
    var owner = read(K_OWNER) || '';

    if (!me) {
      setState('guest');
      /* Signed out since the last page? Hand the cart's current lines over to
         the account that left them and start this guest clean. */
      if (owner) return markOrphans().then(function () { return reconcile('signed-out'); });
      return reconcile('guest');
    }

    if (!owner) return adopt();          /* guest -> signed in: claim the basket */
    if (owner !== me) return takeOver();  /* someone else's device state */

    return reconcile('load').then(function () { return pull(true); });
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clearTimeout(pollTimer); return; }
    noteActivity();
    /* Back in the foreground: check for another device's changes, and finish
       anything this device still owes. */
    pull(true);
    if (read(K_DIRTY) === '1') schedulePush(0);
  });

  window.addEventListener('pageshow', function (e) {
    /* bfcache restore - the cart may have changed in another tab entirely. */
    if (e.persisted) { reconcile('pageshow'); pull(true); }
  });

  /* ---- public surface --------------------------------------------------
     For the cart page / drawer: LLCartSync.unavailable() is the list of lines
     the account holds that this cart would not take, so they can be shown as
     "no longer available" instead of vanishing without explanation. */
  window.LLCartSync = {
    state: function () { return { sync: syncState, customerId: me, index: readIdx() }; },
    sync: function () { return reconcile('manual').then(function () { return pull(true); }); },
    pull: function () { return pull(true); },
    push: function () { return push(0); },
    unavailable: function () {
      var miss = readMissing(), idx = readIdx(), out = [];
      for (var k in miss) {
        /* The account is the authority. A line the shopper has since removed
           somewhere else is not "unavailable", it is gone - do not go on
           offering it. */
        var line = idx.l[k];
        if (!line || line.q <= 0) continue;
        var m = miss[k].m || line.m || {};
        out.push({
          lineKey: k,
          variantId: miss[k].i,
          quantity: line.q,
          handle: m.h || '',
          title: m.n || '',
          image: m.im || '',
          url: m.h ? (root() + 'products/' + m.h) : '',
          reason: miss[k].why
        });
      }
      return out;
    },

    /* Drop a line from the account outright. This is the "remove" on an
       unavailable row: it tombstones like any other removal, so it travels to
       the shopper's other devices instead of coming back on the next sync. */
    forgetLine: function (lineKey) {
      var idx = readIdx();
      var line = idx.l[lineKey];
      if (!line) return false;
      idx.l[lineKey] = {
        i: line.i, q: 0, t: now(), p: line.p, s: line.s, m: line.m || null
      };
      writeIdx(idx);
      clearMissing(lineKey);
      schedulePush(0);
      emit('applied', { cart: null });
      return true;
    },
    /* Tombstone lines the shopper deliberately removed, addressed by Shopify
       LINE KEYS rather than index keys.

       Needed because the two are not the same thing. This index is keyed by
       variant + properties + selling plan, so a plain line lives under its
       bare variant id, while Shopify addresses the same line as
       <variantId>:<hash>. forgetLine expects the former; the cart page only
       ever has the latter, so calling it with a line key silently matched
       nothing and recorded no removal at all.

       Without a tombstone, a bulk clear reaches the next page load looking
       exactly like a cart wipe (every line gone, no request to explain it,
       because the reload beat the reconcile debounce) and the index puts the
       basket straight back. */
    forgetCartLines: function (cartLineKeys) {
      if (!cartLineKeys || !cartLineKeys.length) return 0;
      var seen = readSeen();
      var idx = readIdx();
      var t = now();
      var byCartKey = {};
      var lk;
      for (lk in seen.l) { if (seen.l[lk].key) byCartKey[seen.l[lk].key] = lk; }

      var hit = 0;
      for (var i = 0; i < cartLineKeys.length; i++) {
        var ck = String(cartLineKeys[i] || "");
        if (!ck) continue;
        var target = byCartKey[ck];
        /* Records written before the key was stored, and the ordinary case of
           a line with no properties, both resolve from the variant id, which
           is the part of the line key before the colon. */
        if (!target) {
          var vid = ck.split(":")[0];
          if (idx.l[vid]) target = vid;
        }
        var line = target ? idx.l[target] : null;
        if (!line || line.q === 0) continue;
        idx.l[target] = { i: line.i, q: 0, t: t, p: line.p, s: line.s, m: line.m || null };
        clearMissing(target);
        hit++;
      }
      if (!hit) return 0;
      prune(idx);
      writeIdx(idx);
      sawCartMutation = true;
      schedulePush(0);
      emit('applied', { cart: null });
      return hit;
    },
    forget: function () {
      drop(K_IDX); drop(K_SEEN); drop(K_OWNER); drop(K_ORPH); drop(K_MISS); drop(K_DISC); drop(K_DIRTY);
    }
  };

  /* Patch immediately, not at DOMContentLoaded. A theme that fires an
     add-to-cart before the DOM is ready would otherwise slip past unseen, and
     an unseen add is an add this device never stamps. */
  patchNetwork();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); schedulePoll(); });
  } else {
    boot();
    schedulePoll();
  }
})();
